module.exports = __webpack_public_path__ + "img/Logo.8867ae0f.svg";